import { render, staticRenderFns } from "./TdsCertificate.vue?vue&type=template&id=af9180ac"
import script from "./TdsCertificate.vue?vue&type=script&lang=js"
export * from "./TdsCertificate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports